import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useHistory } from "react-router-dom";

import { LocationChangePromptBottomSheet } from "./LocationChangePromptBottomSheet";
import { useDismissLocationChangePrompt, useLocationChangePrompt } from "./useLocationChangePrompt";

export function LocationChangePromptContainer() {
  const { modalState, distanceInMiles, cooldownInMs } = useLocationChangePrompt();
  const dismiss = useDismissLocationChangePrompt();
  const history = useHistory();

  useLogEffect(
    APP_V2_USER_EVENTS.LOCATION_CHANGE_PROMPT_VIEWED,
    { distanceInMiles },
    { enabled: modalState.modalIsOpen }
  );

  return (
    <LocationChangePromptBottomSheet
      modalState={modalState}
      onUpdateAddress={() => {
        logEvent(APP_V2_USER_EVENTS.LOCATION_CHANGE_PROMPT_ACCEPTED, { distanceInMiles });
        modalState.closeModal();
        history.push(DeprecatedGlobalAppV1Paths.ADDRESS);
      }}
      onDismiss={() => {
        logEvent(APP_V2_USER_EVENTS.LOCATION_CHANGE_PROMPT_DISMISSED, { distanceInMiles });
        dismiss(cooldownInMs);
        modalState.closeModal();
      }}
    />
  );
}
